import { useEffect, useState } from 'react';
import { useAdminStore } from '@/pages/admin/store/useAdmin.store';
import { useDashboardStore } from '../store/useDashboardStore';
import SchoolsFilter from '@/components/SchoolsFilter';

export default function Title() {
  const { page } = useAdminStore();
  const { setValues } = useDashboardStore();
  const [selectedSchools, setSelectedSchools] = useState<string[]>([]);

  useEffect(() => {
    setSelectedSchools([]);
    setValues({ schoolsIds: [] });
  }, [setValues]);

  const handleSchoolChange = (selectedIds: string[]) => {
    setSelectedSchools(selectedIds);
    setValues({
      schoolsIds: selectedIds.length > 0 ? selectedIds : [],
    });
  };

  return (
    <div className="flex flex-col items-center gap-4 md:flex-row md:justify-center">
      <h1 className="flex self-center text-sh-24 font-bold">{page?.dashboard?.title || 'School Dashboard'}</h1>
      <SchoolsFilter selectedSchoolsIds={selectedSchools} onChange={handleSchoolChange} />
    </div>
  );
}
